export default __webpack_public_path__ + "static/media/beatriz.96b7068c.jpg";